import { ticketStatus } from "../lib/format";

/** Colored badge for a ticket's status, resolved from its (opaque) status_id. */
export function StatusBadge({ statusId }: { statusId: string | null | undefined }) {
  const { label, tone } = ticketStatus(statusId);
  return <span className={`badge status-${tone}`}>{label}</span>;
}
